module.exports = __webpack_public_path__ + "img/20001.e3528a34.png";